/* eslint sort-keys-fix/sort-keys-fix: ["error", "asc", {natural: false}] */
const strings: { [key in string]: string } = {
  ACCOUNT: 'Cuenta',
  ACCOUNTING_AND_AUDITING: 'Contabilidad y Auditoría',
  ACCOUNT_ALREADY_EXISTS: 'La cuenta ya existe',
  ACCOUNT_DETAILS: 'Detalles de la cuenta',
  ACCOUNT_INFORMATION_ERROR:
    'Hubo un error al encontrar tu cuenta virtual, por favor intenta de nuevo más tarde.',
  ACCOUNT_NOT_FOUND: 'Cuenta no encontrada',
  ACCOUNT_NUMBER: 'Número de cuenta',
  ACCOUNT_NUMBER_COPIED: 'Número de cuenta copiado con éxito',
  ACCOUNT_NUMBER_DETAILS: 'Número de cuenta',
  ACCOUNT_NUMBER_WITH_CURRENCY: 'Número de cuenta ({0})',
  ACCOUNT_TYPE: 'Tipo de cuenta',
  ACH: 'ACH',
  ACTION_REQUIRED: 'Acción requerida',
  ACTIVE: 'Activo',
  ACTIVITY: 'Actividad',
  ADD: 'Agregar',
  ADDRESS: 'Dirección',
  ADDRESS_COMPLEMENT: 'Complemento de dirección',
  ADD_CONTACT: 'Agregar contacto',
  ADD_CONTACT_FLOW_MODAL_CURRENCY_DESCRIPTION: 'Moneda: {0}',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_ACH: 'ACH o Wire',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_COP: 'ACH Colombia',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CVU: 'Transferencia bancaria (CVU o CBU)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PIX: 'Pix',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SPEI: 'Spei',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SWIFT: 'Swift',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_WIRE: 'ACH o Wire',
  ADD_DIGITAL_DOLLARS: 'Agregar dólares digitales',
  ADD_DOCUMENTS: 'Agregar documentos',
  ADD_NEW: 'Agregar nuevo',
  ADD_NEW_CONTACT: 'Agregar nuevo contacto',
  ADD_NEW_CONTACT_WHICH_TYPE: '¿Qué tipo de contacto te gustaría agregar?',
  ADD_NEW_CUSTOMER: 'Agregar nuevo cliente',
  ADD_NEW_RECIPIENT: 'Agregar nuevo destinatario',
  ADD_NEW_ROLE: 'Agregar nuevo rol',
  ADD_NEW_USER: 'Agregar nuevo usuario',
  ADD_NEW_WITHDRAWAL_ACCOUNT: 'Agregar nueva cuenta de retiro',
  ADD_PAYMENT_METHOD: 'Agregar método de pago',
  ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE:
    '¿Deseas agregar un método de pago a un contacto existente o a uno nuevo?',
  ADD_YOUR_BUSINESS_INFORMATION: 'Agregar información de tu negocio',
  ADMIN: 'Administrador',
  ADMINISTRATOR: 'Administrador',
  ADMIN_DESCRIPTION:
    'Gestión de equipo, capacidades de transacción, ver y descargar historial de transacciones y reportes de actividad',
  ALL: 'Todos',
  ALREADY_HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
  AMOUNT: 'Monto',
  AMOUNT_ADDED_TO_WALLET: 'Monto agregado a la cartera',
  AMOUNT_BIGGER_THAN_BALANCE: 'El monto no puede ser mayor que tu saldo (${0})',
  AMOUNT_TO_CONVERT: 'Monto a convertir',
  AND_READ_UNDERSTOOD_OUR: 'y que has leído y entendido nuestra',
  ANY: 'Cualquiera',
  AN_ERROR_OCCURRED: 'Ocurrió un error desconocido, por favor intenta de nuevo más tarde.',
  APPEARANCE: 'Apariencia',
  APPLY: 'Aplicar',
  APPROVED: 'Aprobado',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_DESCRIPTION: 'Esta acción no es reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_TITLE:
    '¿Estás seguro de que quieres eliminar esta cuenta?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_DESCRIPTION: 'Esta acción no es reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_TITLE:
    '¿Estás seguro de que quieres eliminar este contacto?',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_WITHOUT_HASH:
    '¿Estás seguro de que quieres salir sin proporcionar un hash de transacción?',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THESE_USERS_FROM_YOUR_TEAM: `Tem certeza que deseja remover {0} da sua equipe?`,
  ASSET_TYPE: 'Tipo de activo',
  BACK: 'Atrás',
  BACK_TO_APPLICATION: 'Volver a la aplicación',
  BACK_TO_DASHBOARD: 'Volver al panel',
  BACK_TO_LOGIN: 'Volver a iniciar sesión',
  BALANCE: 'Saldo',
  BANK: 'Banco',
  BANK_ACCOUNT: 'Cuenta bancaria',
  BANK_ACCOUNT_INFORMATION: 'Información de la cuenta bancaria',
  BANK_ACCOUNT_NUMBER: 'Número de cuenta bancaria',
  BANK_ACCOUNT_TYPE: 'Tipo de cuenta bancaria',
  BANK_CODE: 'Código de banco',
  BANK_INFORMATION: 'Información bancaria',
  BANK_NAME: 'Nombre del banco',
  BENEFICIARY_NAME: 'Nombre del beneficiario',
  BENEFICIARY_OR_RECIPIENT_CONTACT: 'Contacto del beneficiario o destinatario',
  BRAZILIAN_PIX: 'Real brasileño (Pix)',
  BRL_MARKET_HOURS_ALERT:
    'Esta operación solo se puede completar durante el horario comercial: de lunes a viernes, de 9:00 a 15:40 BRT (excepto días festivos).',
  BUSINESS: 'Empresa',
  BUSINESS_EMAIL: 'Correo electrónico de negocios',
  BUSINESS_INFORMATION: 'Información de la empresa',
  BUSINESS_NAME: 'Nombre de la empresa',
  BUSINESS_RELATIONSHIP: 'Relación comercial',
  BY_CONFIRMING_EMAIL_AGREE: 'Al confirmar tu email, aceptas nuestros',
  CALIZA_ACCOUNT: 'Cuenta Caliza ({0})',
  CALIZA_DOES_NOT_CHARGE_DEPOSIT_FEES:
    'Caliza no cobra ninguna comisión por depósito. Sin embargo, tu cartera externa puede cobrar comisiones por transferir fondos.',
  CALIZA_TERMS_AND_SERVICES: 'Términos y Servicios de Caliza',
  CALIZA_WALLET: 'Cartera Caliza',
  CALIZA_WALLET_BALANCE: 'Saldo de cartera Caliza',
  CANCEL: 'Cancelar',
  CANCEL_TRANSFER: 'Cancelar transferencia',
  CANT_SCAN_THE_CODE: '¿No puedes escanear el código?',
  CHAIN: 'Cadena',
  CHAIN_ETHEREUM: 'Ethereum',
  CHAIN_POLYGON: 'Polygon',
  CHAIN_TRON: 'TRON',
  CHAIN_UNKNOWN: 'Desconocido',
  CHANGE_PASSWORD_DESCRIPTION: 'Confirmación cuando se cambie tu contraseña',
  CHANGE_PASSWORD_LABEL: 'Cambiar contraseña',
  CHECKING: 'Cuenta corriente',
  CHECK_EMAIL_FOR_CODE: 'Por favor, consulta {0} para obtener tu código de un solo uso',
  CHECK_HISTORY_DESCRIPTION:
    'Revisa tu historial para seguir el estado de la transferencia. Los detalles de la transacción pueden tardar unos minutos antes de aparecer.',
  CHECK_YOUR_PAYMENT_HISTORY_TO_TRACK_STATUS:
    'Revisa tu historial de pagos para rastrear el estado del pago.',
  CHOOSE_DEPOSIT_AMOUNT: 'Elige el monto del depósito',
  CITY: 'Ciudad',
  CLOSE: 'Cerrar',
  CODE_EXPIRED: 'El código ha expirado. Por favor, solicita uno nuevo',
  CODE_RESENT: 'Código reenviado',
  COMMA_AND_ONE: ', y un',
  COMMA_ONE: ', un',
  COMPANY: 'Empresa',
  COMPLETED: 'Completado',
  COMPLETED_DESCRIPTION:
    'Recibe notificaciones cuando una transferencia esté completa y el destinatario haya recibido sus fondos',
  COMPLETED_LABEL: 'Completo',
  COMPLETED_STATUS: 'Completado',
  CONFIRM_NEW_PASSWORD: 'Confirmar nueva contraseña',
  CONFIRM_PASSWORD: 'Confirmar contraseña',
  CONFIRM_PAYMENT: 'Confirmar pago',
  CONFIRM_WITHDRAWAL: 'Confirmar retiro',
  CONTACT: 'Contacto',
  CONTACTS: 'Contactos',
  CONTACT_DETAILS: 'Detalles del contacto',
  CONTACT_NICKNAME: 'Apodo del contacto',
  CONTACT_TYPE: 'Tipo de contacto',
  CONTINUE: 'Continuar',
  CONTINUE_WITH_GOOGLE: 'Continuar con Google',
  CONVERSION_QUOTE: 'Cotización de conversión',
  CONVERSION_RATE: 'Tasa de conversión',
  CONVERSION_RATE_TOOLTIP: 'La tasa de conversión incluye {0} de spread de divisas',
  CONVERT: 'Convertir',
  CONVERTED_CURRENCY: 'Moneda convertida',
  CONVERT_ACCOUNT_BALANCE: 'Convertir saldo de la cuenta',
  CONVERT_SUCCESS: 'Conversión completada con éxito',
  COPY_CLABE: 'Copiar CLABE',
  COPY_LINK: 'Copiar enlace',
  COUNTRY: 'País',
  COUNTRY_OF_RESIDENCE: 'País de residencia',
  COUNT_OF_COUNT_COMPLETE: '{0} de {1} completo',
  CO_CC_LABEL: 'Cédula de Ciudadanía',
  CO_CE_LABEL: 'Cédula de Extranjería',
  CO_NIT_LABEL: 'Número de Identificación Tributaria',
  CO_SPECIAL_RESIDENCE_PERMIT: 'Permiso Especial de Permanencia',
  CREATED: 'Creado',
  CREATED_DESC: 'Su transacción fue creada.',
  CREATE_A_CALIZA_ACCOUNT: 'Crear una\ncuenta Caliza',
  CREATE_CUSTOM_ROLE_NAME: 'Crear un nombre para este rol personalizado:',
  CREATE_INTEGRATOR_SUCCESS: 'Integrator created successfully',
  CREATE_TRANSACTIONS: 'Crear transacciones',
  CREATE_USER_FAILED: 'Se produjo un error al crear el usuario',
  CREATE_USER_SUCCESS: 'Usuario creado exitosamente',
  CROSS_BORDER_SUPPLY_CHAIN: 'Cadena de Suministro Transfronteriza',
  CROSS_BORDER_SUPPLY_CHAIN_DESC: 'Simplifica las cuentas por pagar y por cobrar internacionales',
  CRYPTO_DEPOSIT_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_DEPOSIT_COMPLETED_TITLE: 'Once we receive your funds, we will complete your deposit',
  CRYPTO_HASH_TRANSFER_MODAL_DESCRIPTION:
    'The transaction hash to automatically reconcile your incoming deposit.',
  CRYPTO_HASH_TRANSFER_MODAL_TITLE: 'Share the transaction hash provided by your external wallet',
  CRYPTO_TRANSFER_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_TRANSFER_COMPLETED_TITLE: 'Once we receive your funds, we will complete your transfer',
  CRYPTO_TRANSFER_MODAL_DESCRIPTION:
    'Copia el hash de la transacción de tu billetera o exchange y pégalo aquí para que podamos verificar tu depósito. Una vez confirmado, tu transferencia se completará y aparecerá en tu historial de transacciones.',
  CRYPTO_TRANSFER_MODAL_TITLE: 'Comparte el hash de la transacción para completar tu operación',
  CURRENCY_CONVERT_TO_DIGITAL_DOLLARS:
    '{0} se convertirá automáticamente a dólares digitales una vez que recibamos tu depósito.',
  CURRENCY_TYPE: 'Tipo de moneda',
  CURRENCY_TYPE_LABEL: 'Tipo de moneda',
  CURRENT_PASSWORD: 'Contraseña actual',
  CUSTOM: 'Personalizado',
  CUSTOMERS: 'Clientes',
  CUSTOMER_SUCCESS: 'Éxito del Cliente',
  CUSTOMER_TYPE: 'Tipo de cliente',
  CUSTOMER_VERIFICATION_CREATE_ERROR: 'Error al crear la verificación del cliente',
  CUSTOMER_VERIFICATION_ERROR: 'Ocurrió un error durante la verificación',
  CUSTOMER_VERIFICATION_STARTED_SUCCESS: 'Verificación del cliente iniciada con éxito',
  CUSTOMER_VERIFICATION_STATUS_INFO:
    'Por favor complete la configuración para verificación y continuar con las transferencias',
  CUSTOMER_VERIFICATION_SUCCESS: 'Verificación completada con éxito',
  CVU: 'CVU',
  CVU_OR_CBU: 'CVU o CBU',
  DARK: 'Oscuro',
  DATE: 'Fecha',
  DATE_AND_TIME: 'Fecha y hora',
  DAY: 'Día',
  DEACTIVATE_ACCOUNT: 'Desactivar cuenta',
  DECLINED: 'Rechazado',
  DELETE_ACCOUNT: 'Eliminar cuenta',
  DELETE_CONTACT: 'Eliminar contacto',
  DELETE_CONTACT_SUCCESS: 'Contacto eliminado con éxito',
  DELETE_PAYMENT_METHOD_SUCCESS: 'Método de pago eliminado con éxito',
  DEPARTMENT: 'Departamento',
  DEPOSIT: 'Depósito',
  DEPOSITO_DE: 'Depósito de {0}',
  DEPOSIT_COMPLETED: 'Depósito Completado',
  DEPOSIT_COMPLETED_DESC: 'Su depósito ha sido completado.',
  DEPOSIT_COMPLETED_TITLE: 'Tus fondos han sido agregados',
  DEPOSIT_FIAT_ACCOUNT_MODAL_DESCRIPTION:
    'Una vez que recibamos tus fondos de tu banco, automáticamente enviaremos tu transferencia y confirmaremos por correo electrónico y en tu historial de transacciones.',
  DEPOSIT_FIAT_ACCOUNT_MODAL_TITLE: 'Envía fondos desde tu banco para completar la transferencia',
  DEPOSIT_FROM: 'Depósito de {0}',
  DEPOSIT_PENDING_TITLE: 'Estamos depositando tus fondos',
  DEPOSIT_RECEIVED: 'Depósito Recibido',
  DEPOSIT_RECEIVED_DESC: 'Su depósito ha sido recibido.',
  DESCRIPTION_OF_ROLE_OPTIONAL: 'Descripción del Rol (Opcional)',
  DESELECT_ALL: 'Deseleccionar todo',
  DESTINATION_COUNTRY: 'País de la cuenta del destinatario',
  DETAILS: 'Detalles',
  DEVICE_NAME: 'Nombre del dispositivo',
  DEVICE_NAME_HELP: 'Opcional: Dale un nombre a este dispositivo para identificarlo fácilmente',
  DEVICE_NAME_PLACEHOLDER: 'Mi Teléfono',
  DIGITAL_DOLLAR: 'Dólar digital',
  DISABLE: 'Inhabilitar',
  DISABLE_TWO_FACTOR_AUTHENTICATION_TITLE:
    '¿Estás seguro de que quieres desactivar la autenticación de dos factores?',
  DISABLING: 'Deshabilitando...',
  DOCUMENT_WITH_NAME_TEMPLATE: 'Documento {0}',
  DONE: 'Hecho',
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  DONT_SUPPORT_COUNTRY: "We don't support your country yet",
  DOWNLOAD_COMPROVANTE_OPERACAO_TRANSACTION_DOCUMENT:
    'Comprovante de operação de pagamento internacional',
  DOWNLOAD_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Confirmación de transacción',
  DOWNLOAD_STATEMENT: 'Descargar estado de cuenta',
  DOWNLOAD_TRANSACTION_DOCUMENTS: 'Descargar comprobantes de transacción',
  EDIT: 'Editar',
  EDIT_RECIPIENT_TABS: 'Editar pestañas de destinatario',
  EIGHT_CHARACTERS: 'ocho caracteres',
  EMAIL: 'E-mail',
  EMAIL_INVALID_FORMAT: 'El formato del correo electrónico no es válido',
  ENABLE: 'Habilitar',
  ENABLING: 'Habilitando...',
  ENTER_TOTP_CODE: 'Ingresar código',
  ENTER_VERIFICATION_CODE: 'Ingresa el código de verificación',
  ENTER_VERIFICATION_CODE_DESCRIPTION:
    'Ingresa el código de 6 dígitos de tu aplicación autenticadora para completar la configuración',
  ERROR_DISPLAYING_ROW_DATA: 'Error al mostrar datos de la fila',
  ERROR_LOADING_CUSTOMER: 'Error al cargar los detalles del cliente',
  ERROR_LOADING_PREFERENCES: 'Error al cargar preferencias',
  EXCHANGE: 'Cambio',
  EXCHANGE_COMPLETED: 'Cambio completado',
  EXISTING_CONTACT: 'Contacto existente',
  EXPIRED: 'Expirado',
  EXPIRED_DESC: 'Esta transacción ha expirado',
  EXTERNAL_ACCOUNT: 'Externo',
  EXTERNAL_ACCOUNT_ACH: 'Externo: ACH',
  EXTERNAL_ACCOUNT_PIX: 'Externo: Pix',
  EXTERNAL_ACCOUNT_SWIFT: 'Externo: Swift',
  EXTERNAL_ACCOUNT_WIRE: 'Externo: Wire',
  EXTERNAL_PAYMENT_REFERENCE_OPTIONAL: 'Referencia de pago externo (Opcional)',
  EXTERNAL_RECIPIENT: 'Destinatario externo',
  FAILED: 'Fallido',
  FAILED_DESC: 'Su pago ha fallado',
  FAILED_DESCRIPTION: 'Recibe notificaciones cuando una transferencia haya fallado',
  FAILED_LABEL: 'Fallido',
  FAILED_TO_LOAD_TRANSACTION_STATUS: 'Error al cargar el estado de la transacción',
  FEATURE_NOT_AVAILABLE_DESCRIPTION:
    'Pedimos disculpas por el inconveniente. Esta función existe pero está temporalmente deshabilitada. Por favor, vuelve más tarde para ver las actualizaciones.',
  FEATURE_NOT_AVAILABLE_TITLE: 'Función actualmente no disponible',
  FEE: 'Tarifa',
  FEES: 'Comisiones',
  FIAT_ACCOUNT_ACH: 'Cuenta Bancaria (ACH)',
  FIAT_ACCOUNT_COP: 'COP',
  FIAT_ACCOUNT_CVU: 'Transferencia bancaria (CVU o CBU)',
  FIAT_ACCOUNT_PIX: 'Pix',
  FIAT_ACCOUNT_SPEI: 'SPEI',
  FIAT_ACCOUNT_SWIFT: 'Cuenta Bancaria (SWIFT)',
  FIAT_ACCOUNT_WIRE: 'Cuenta Bancaria (Wire)',
  FILE_NAME_AND_SIZE_TEMPLATE: 'Nombre del archivo {0} - {1}',
  FILL_ALL_ENTRIES_AND_SUBMIT: 'Completa todas las entradas y envía',
  FILL_OUT_DETAILS_FOR_NEW_MEMBER: 'Rellena los detalles para el nuevo miembro',
  FILTER: 'Filtrar',
  FILTER_WITH_COUNT: 'Filtrar ({0})',
  FINANCE_AND_TREASURY: 'Finanzas y Tesorería',
  FIRST_NAME: 'Nombre',
  FOUR_STEPS_BEFORE_FIRST_PAYMENT: 'Cuatro pasos antes de tu primer pago',
  FROM: 'De',
  FROM_DATE: 'Desde (MM/AA)',
  FUNCTIONALITIES: 'Funcionalidades',
  FUNDING_METHOD: 'Método de financiamiento',
  FUNDING_WITH: 'Financiar con {0}',
  FX_RATE: 'Cambio',
  GET_HELP: 'Obtener ayuda',
  GLOBAL_BUSINESS_ACCOUNTS: 'Cuentas empresariales globales en dólares digitales',
  GLOBAL_MERCHANT_SETTLEMENT: 'Liquidación de Comercio Global',
  GLOBAL_MERCHANT_SETTLEMENT_DESC: 'Pagos instantáneos para marketplaces, e-commerce y plataformas',
  GROSS_AMOUNT: 'Monto bruto',
  HELP: 'Ayuda',
  HIDE_ROLE_DETAILS: 'Ocultar detalles del rol',
  HOME: 'Inicio',
  HOUR: 'hora',
  HOURS: 'horas',
  IBAN: 'IBAN',
  IBAN_ACCOUNT_NUMBER: 'IBAN / Número de cuenta',
  IBAN_DETAILS: 'IBAN',
  IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER: 'Número de cuenta inválido',
  IBAN_VALIDATION_INVALID_COUNTRY: 'IBAN inválido del país {0}, para el país {1}',
  IBAN_VALIDATION_INVALID_FORMAT: 'Formato IBAN inválido',
  IBAN_VALIDATION_INVALID_IBAN: 'IBAN inválido',
  IBAN_VALIDATION_TOO_SHORT_4: 'Debe tener más de 4 caracteres',
  'ID_#': 'ID #',
  INCOMPLETE_STATUS: 'Incompleto',
  INCORRECT_CODE: 'Código incorrecto. Por favor, inténtalo de nuevo',
  INCORRECT_EMAIL_PASSWORD: 'Correo electrónico o contraseña incorrectos',
  INDIVIDUAL: 'Individuo',
  INFORMATION_FOR_PAYMENT_BENEFICIARY_OR_RECIPIENT:
    'Información para beneficiario o destinatario del pago',
  INITIATED_BY: 'Iniciado por',
  INSTALL_AUTHENTICATOR_APP: 'Instala una aplicación autenticadora',
  INSTALL_AUTHENTICATOR_APP_DESCRIPTION: 'Descarga e instala una aplicación autenticadora como {0}',
  INSTANT_GLOBAL_PAYMENTS: 'Pagos globales instantáneos',
  INSUFFICIENT_FUNDS: 'Fondos insuficientes',
  INTERNAL_NOTES_DESCRIPTION:
    'Puedes ver adjuntos y notas en tu actividad para referencia futura. Esto es solo para tus ojos.',
  INTERNAL_NOTES_OPTIONAL: 'Notas internas (Opcional)',
  INTERNAL_TRANSFER_COMPLETED: 'Transferencia interna completada',
  INTERNAL_TRANSFER_NOTES: 'Notas internas de transferencia o memo',
  INTERNATIONAL_PAYROLL: 'Nómina Internacional',
  INTERNATIONAL_PAYROLL_DESC: 'Paga a tu fuerza laboral internacional en dólares digitales',
  INVALID_OTP: 'Código inválido. Por favor intenta de nuevo.',
  INVALID_SWIFT_CODE_FOR_IBAN: 'El código Swift no coincide con el IBAN',
  INVITATION_SENT: 'Invitación enviada',
  INVITE: 'Invitar',
  INVITE_A_TEAM_MEMBER: 'Invitar a un miembro de la equipo',
  INVOICES_RECEIPTS_ETC: '(Facturas, recibos, etc)',
  IN_PROGRESS: 'En progreso',
  IOF_WITH_PERCENTAGE: `IOF ({0})`,
  IS_POBO: 'Estoy instruyendo este pago en nombre de mi cliente',
  I_AGREE_TO_THE:
    'Por la presente declaro que la información que estoy proporcionando es veraz y precisa según mi conocimiento y he leído y acepto ',
  JOIN_YOUR_TEAM_ON_CALIZA: 'Únete a tu equipo en Caliza',
  KEEP_ACCOUNT: 'Mantener cuenta',
  KEEP_CONTACT: 'Mantener contacto',
  KEEP_TWO_FACTOR_AUTHENTICATION_ENABLED: 'Mantener 2FA',
  LABEL_OR_TITLE: 'etiqueta',
  LANGUAGE: 'Idioma',
  LAST_NAME: 'Apellido',
  LEADERSHIP_EXECUTIVE: 'Liderazgo / Ejecutivo',
  LEAVE_ANYWAY: 'Abandonar de todas formas',
  LEAVE_WITHOUT_HASH_DESC: 'Las operaciones sin hash de transacción tardan más en completarse.',
  LEGAL: 'Legal',
  LEGAL_ENTITY_NAME: 'Nombre de entidad legal',
  LIGHT: 'Claro',
  LINK_ACCOUNT: 'Vincular cuenta',
  LINK_COPIED: 'Enlace copiado correctamente',
  LOADING_PLEASE_WAIT: 'Cargando, por favor espera',
  LOADING_TRANSACTION_STATUS: 'Cargando estado de la transacción',
  LOGIN_AND_SECURITY: 'Inicio de sesión y seguridad',
  LOG_IN: 'Iniciar sesión',
  MAKE_A_TRANSFER: 'Hacer una transferencia',
  MANAGE_PAYMENT_CONTACTS: 'Gestionar contactos de pago',
  MANAGE_PAYOUTS: 'Gestiona pagos o recibe fondos instantáneamente en stablecoins',
  MANAGE_ROLES: 'Administrar roles',
  MANAGE_TEAM_AND_USERS: 'Gestionar equipo y usuarios',
  MANAGE_USER: 'Administrar usuario',
  MANAGE_USERS: 'Gestionar usuarios',
  MANUAL_ENTRY_OPTION: 'O ingresa esta clave manualmente en tu aplicación autenticadora:',
  MAX: 'Máximo',
  MEMO_OR_DESTINATION_OPTIONAL: 'Memo or Destination Tag (Optional)',
  METHOD: 'Método',
  MEXICAN_SPEI: 'Pesos mexicanos (SPEI)',
  MID_MARKET_RATE: 'Tasa de mercado',
  MINUTES: 'minutos',
  MISSING_INTEGRATOR_INFORMATION: 'Falta información del integrador, por favor complete KYB',
  MONTH: 'Mes',
  MORE: '+{0} más',
  NAME: 'Nombre',
  NEW_CONTACT: 'Contacto nuevo',
  NEW_DEVICE_LOGIN_DESCRIPTION: 'Inicios de sesión desde un nuevo dispositivo',
  NEW_DEVICE_LOGIN_LABEL: 'Inicio de sesión en nuevo dispositivo',
  NEW_PASSWORD: 'Nueva contraseña',
  NEXT: 'Siguiente',
  NICKNAME: 'Apodo',
  NICKNAME_REQUIRED_ERROR: 'El apodo no puede estar vacío',
  NINE_MIN: '9 min',
  NO: 'No',
  NOTIFICATIONS: 'Notificaciones',
  NOT_APPLICABLE: 'N/A',
  NOT_STARTED: 'No iniciado',
  NO_ACCOUNTS: 'No hay cuentas disponibles',
  NO_ACTIVITY_YET_SUBTITLE: 'Envía o recibe fondos y aparecerán aquí.',
  NO_ACTIVITY_YET_TITLE: 'Aún no hay actividad',
  NO_CUSTOMERS_YET_TITLE: 'Aún no hay clientes agregados',
  NO_ILL_WAIT: 'No, esperaré',
  NO_ITEMS_FOUND: 'No se encontraron elementos',
  NO_NUMBER: 'La contraseña debe tener al menos 1 número',
  NO_RECIPIENT_ACCOUNTS: 'No hay cuentas de destinatario',
  NO_SPECIAL_CHARACTER: 'La contraseña debe tener al menos 1 carácter especial',
  NUMBER: 'número',
  ONE_TIME_PASSWORD: 'Verificar con autenticación de dos factores',
  ONE_TIME_PASSWORD_DESCRIPTION:
    'Ingresa el código temporal generado en tu aplicación autenticadora',
  ONLY_CURRENCY_SUPPORTED_BY_COUNTRY: 'Solo {0} son compatibles con este país.',
  ONLY_FOR_DOMESTIC_ACH_AND_WIRES: '(For domestic ACH & Wire only)',
  OPERATIONS: 'Operaciones',
  OPERATIONS_WITHOUT_A_TRANSACTION_HASH_TAKE_LONGER:
    'Las operaciones sin un hash de transacción tardan más en completarse.',
  OPERATOR: 'Operador',
  OPERATOR_DESCRIPTION:
    'Capacidades de transacción, ver y descargar historial de transacciones y reportes de actividad',
  OTHER: 'Otro',
  PASSPORT: 'Passport',
  PASSWORD: 'Contraseña',
  PASSWORDS_DO_NOT_MATCH: 'Las contraseñas no coinciden',
  PASSWORD_IS_EMPTY_ERROR: 'La contraseña no puede estar vacía',
  PASSWORD_MINIMUM: 'La contraseña debe tener un mínimo de',
  PAYMENT_BENEFICIARY_INFO: 'Información para beneficiario o destinatario del pago',
  PAYMENT_COMPLETED: 'Pago completado',
  PAYMENT_COMPLETED_DESC: 'Su pago ha sido completado.',
  PAYMENT_METHOD: 'Método de pago',
  PAYMENT_METHODS: 'Métodos de pago',
  PAYMENT_METHOD_TITLE: 'Método de pago',
  PAYMENT_RAIL_FEE: 'Tarifa {0}',
  PAYMENT_REFERENCE: 'Referencia de pago (máximo 35 caracteres)',
  PAYMENT_REFERENCE_DESCRIPTION:
    'Esta es una referencia opcional de pago para que tu destinatario vea y verifique tu transferencia.',
  PAYMENT_REFERENCE_DETAILS_LABEL: 'Referencia de pago',
  PAYMENT_REFERENCE_LABEL: 'Referencia de pago (máximo 200 caracteres)',
  PAYMENT_SENT: 'Pago enviado',
  PAYMENT_SENT_DESC: 'Su pago ha sido enviado.',
  PAYMENT_SENT_DESCRIPTION:
    'Recibe notificaciones cuando una transferencia esté en progreso, en camino al destinatario',
  PAYMENT_SENT_LABEL: 'Pago enviado',
  PAYMENT_UNDER_REVIEW: 'Pago Bajo Revisión',
  PAYMENT_UNDER_REVIEW_DESC: 'Su pago está siendo revisado para cumplimiento.',
  PENDING: 'Pendiente',
  PENDING_DESC: 'Su pago está procesándose',
  PERSONAL_INFORMATION: 'Información personal',
  PIX: 'Pix',
  PIX_DEPOSIT_DESCRIPTION:
    'Una vez que estés en tu aplicación bancaria, usa el enlace a continuación para completar tu depósito usando Pix. Te enviaremos una confirmación por correo electrónico una vez que se reciba tu depósito.',
  PIX_KEY: 'Clave PIX',
  PIX_KEY_DETAILS: 'Clave Pix',
  PREFERRED_LANGUAGE: 'Idioma preferido',
  PREVIEW: 'Vista previa',
  PRIVACY_POLICY: 'Política de Privacidad',
  PROCEED_WITH_ACTION: 'Continuar con la acción',
  PROCESSED_BY_BANK: 'Procesado por el Banco',
  PROCESSED_BY_BANK_DESC: 'Su pago ha sido procesado por el banco emisor.',
  PROCESSED_BY_INTERMEDIARY_BANK: 'Procesado por Banco Intermediario',
  PROCESSED_BY_INTERMEDIARY_BANK_DESC: 'Su pago ha sido procesado por el banco intermediario.',
  PROCESSING: 'Procesando',
  PROCESSING_DESC: 'Su pago está siendo procesado.',
  PRODUCT_AND_TECHNOLOGY: 'Producto y Tecnología',
  PROFILE: 'Perfil',
  PROVIDE_THE_SIX_DIGIT_CODE: 'Proporciona el código de 6 dígitos de tu aplicación autenticadora',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION:
    'Capital social, transferencias de fondos',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL: 'Inyección de Capital / Inversión',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION: 'Comisiones de ventas, corretaje',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL: 'Comisiones y Honorarios de Agentes',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION: 'Entre entidades relacionadas',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL: 'Transferencias Intercompañía',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION:
    'Bienes y servicios de proveedores',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL: 'Pagos de Facturas y Proveedores',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION: 'Pagos de PI, software, patentes',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL: 'Licencias y Regalías',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION: 'Pagos de préstamos comerciales',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL: 'Pago de Préstamos e Intereses',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION: 'Flete, aduanas, almacenaje',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL: 'Logística y Envíos',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION:
    'Anuncios digitales, campañas, agencias',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL: 'Marketing y Publicidad',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION: 'Alquiler, servicios públicos, seguros',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL: 'Gastos Operativos',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION: 'Salarios, sueldos, freelancers',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL: 'Nómina y Pagos a Contratistas',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION:
    'Honorarios de consultoría, legales, contables',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL: 'Servicios Profesionales',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION: 'IVA, aduanas, regulatorio',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL:
    'Impuestos, Aranceles y Tasas Gubernamentales',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION: 'SaaS, nube, infraestructura TI',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL: 'Servicios Tecnológicos',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION: 'Cartas de crédito, liquidaciones comerciales',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL: 'Financiamiento Comercial',
  QR_CODE: 'Código QR',
  QR_CODE_NOT_AVAILABLE: 'Código QR no disponible',
  QUOTE_WILL_EXPIRE: 'Esta cotización expirará en',
  RECEIVED_BY_BENEFICIARY_BANK: 'Recibido por Banco Beneficiario',
  RECEIVED_BY_BENEFICIARY_BANK_DESC: 'Su pago ha sido recibido por el banco beneficiario.',
  RECEIVED_BY_INTERMEDIARY_BANK: 'Recibido por Banco Intermediario',
  RECEIVED_BY_INTERMEDIARY_BANK_DESC: 'Su pago ha sido recibido por el banco intermediario.',
  RECEIVE_AND_SEND_USD: 'Recibe y envía USD usando tu propio número de cuenta y enrutamiento',
  RECIPIENT: 'Destinatario',
  RECIPIENTS: 'Destinatarios',
  RECIPIENTS_WALLET: "Recipient's wallet address",
  RECIPIENT_DETAILS: 'Detalles del destinatario',
  RECIPIENT_EMAIL: 'Correo electrónico del destinatario',
  RECIPIENT_GETS: 'El destinatario recibe',
  RECIPIENT_ID: 'ID del destinatario',
  RECIPIENT_ID_TYPE: 'Tipo de ID del Destinatario',
  RECIPIENT_INFORMATION: 'Información del destinatario',
  RECIPIENT_MEMO: 'Memo del destinatario',
  RECIPIENT_MEMO_OPTIONAL: 'Memo del destinatario (Opcional)',
  RECIPIENT_NOT_FOUND: 'Destinatario no encontrado',
  RECIPIENT_TYPE: 'Tipo de destinatario',
  REFERENCE: 'Referencia',
  REGISTRATION_NUMBER: 'Número de registro',
  REMOVE: 'Eliminar',
  REMOVE_USERS_BUTTON_LABEL: 'Eliminar {0}',
  REQUIRED_ACCOUNT: 'Select account to continue',
  REQUIRED_AMOUNT: 'Amount cannot be empty',
  REQUIRED_FUNDING_METHOD: 'Select funding method to continue',
  REQUIRED_RECIPIENT: 'Recipient cannot be empty',
  REQUIRED_SUPPORTING_DOCUMENTATION: 'Supporting documentation is required',
  RESEND: 'Reenviar',
  RESEND_CODE: 'Reenviar código',
  RESEND_INVITE: 'Reenviar invitación',
  RESEND_INVITE_ERROR: 'Error al reenviar la invitación',
  RESEND_INVITE_SUCCESS: 'Invitación reenviada con éxito',
  RESET: 'Restablecer',
  RESETTING: 'Restableciendo...',
  RESET_PASSWORD: 'Restablecer contraseña',
  RESET_PASSWORD_DESCRIPTION: 'Ingresa tu contraseña actual para restablecerla',
  RESET_PASSWORD_FAILED: 'Error al restablecer la contraseña. Por favor, inténtalo de nuevo.',
  RESET_PASSWORD_FORBIDDEN: 'Por favor, proporciona tu contraseña actual para restablecerla.',
  RESET_PASSWORD_SUCCESS: 'Contraseña restablecida exitosamente',
  RESET_PASSWORD_TITLE: 'Restablecer contraseña',
  RESULT: 'Resultado',
  RESUME_VERIFICATION: 'Reanudar verificación',
  REVIEW: 'Revisión',
  REVIEW_AND_SUBMIT: 'Revisar y enviar',
  REVIEW_CONVERSION: 'Revisar conversión',
  REVIEW_PROFILE: 'Revisar perfil',
  RISK_AND_COMPLIANCE: 'Riesgo y Cumplimiento',
  ROLE: 'Rol',
  ROLE_CREATE_TRANSACTIONS: 'Crear transacciones',
  ROLE_MANAGE_PAYMENT_CONTACTS: 'Gestionar contactos de pago',
  ROLE_MANAGE_USER: 'Administrar equipo y usuarios',
  ROLE_NAME: 'Nombre del rol',
  ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS:
    'Recibir notificaciones de estado de transacciones',
  ROLE_VIEW_ACTIVITY: 'Ver y descargar historial de transacciones y reporte de actividad',
  ROUTING_NUMBER: 'Número de ruta',
  ROUTING_NUMBER_COPIED: 'Número de ruta copiado con éxito',
  ROUTING_NUMBER_DETAILS: 'Número de ruta',
  ROUTING_NUMBER_WITH_CURRENCY: 'Número de ruta ({0})',
  RUNNING: 'En ejecución',
  SALES: 'Ventas',
  SAMPLE_RESPONSES: 'Respuestas de muestra',
  SAVE: 'Guardar',
  SAVE_AND_CLOSE: 'Guardar y cerrar',
  SAVE_CHANGES: 'Guardar cambios',
  SAVINGS: 'Savings',
  SCAN_QR_CODE: 'Escanea el código QR',
  SEARCH: 'Buscar',
  SEARCH_BY_NAME: 'Buscar por nombre',
  SECURE_AND_COMPLIANT: 'Rampas criptográficas seguras y conformes',
  SEE_ALL: 'Ver todo',
  SEE_DETAILS: 'Ver detalles',
  SELECT_ACCOUNT: 'Seleccionar cuenta',
  SELECT_ALL: 'Seleccionar todo',
  SELECT_CONTACT_TYPE: 'Select contact type',
  SELECT_EXISTING_CONTACT: 'Seleccionar contacto existente',
  SELECT_FILTERS_THAT_APPLY:
    'Selecciona cualquiera de los siguientes filtros para aplicar a tu búsqueda',
  SELECT_FUNDING_CURRENCY: 'Selecciona la moneda de financiamiento',
  SELECT_PAYMENT_METHOD: 'Selecciona un método de pago',
  SELECT_PURPOSE_FOR_TRANSFER: 'Selecciona el propósito de la transferencia',
  SELECT_RECIPIENT_ACCOUNT: 'Selecciona los detalles de la cuenta del destinatario',
  SELECT_RECIPIENT_ACCOUNT_DETAILS: 'Selecciona los detalles de la cuenta del destinatario',
  SELECT_ROLE_FUNCTIONS: 'Selecciona las funciones que tiene este rol:',
  SELECT_TYPE: 'Seleccionar tipo',
  SELECT_WAYS_TO_USE_CALIZA: 'Selecciona las formas en que planeas usar Caliza',
  SEND_FUNDS_FROM_BANK: 'Envía fondos desde tu banco para completar la transferencia',
  SEND_FUNDS_TO_CALIZA_WALLET: 'Envía fondos a tu cuenta Caliza',
  SEND_FUNDS_TO_COMPLETE_TRANSFER: 'Envía fondos para completar la transferencia',
  SEND_TO_RECIPIENT: 'Enviar al destinatario',
  SETTINGS: 'Configuración',
  SETTINGS_UPDATE_ERROR: 'Error al actualizar la configuración. Por favor, intenta de nuevo.',
  SETTINGS_UPDATE_SUCCESS: 'Configuración actualizada exitosamente',
  SETTLEMENT_CURRENCY: 'Moneda de liquidación',
  SETTLEMENT_INSTANT: 'Instantáneo',
  SETTLEMENT_INSTANT_MARKET_HOURS: 'Instantáneo (durante horario de mercado)',
  SETTLEMENT_ONE_TO_THREE_DAYS: '1-3 días hábiles',
  SETTLEMENT_ONE_TO_TWO_DAYS: '1-2 días hábiles',
  SETTLEMENT_SAME_DAY_BEFORE_CUTOFF: 'Mismo día (si se envía antes del corte diario)',
  SETTLEMENT_TIME: 'Tiempo de liquidación',
  SETTLEMENT_UNKNOWN: 'Tiempo de liquidación no disponible',
  SETTLEMENT_WITHIN_15_MINUTES: 'Normalmente dentro de 15 minutos',
  SETTLEMENT_WITHIN_5_MINUTES: 'Normalmente dentro de 5 minutos',
  SETUP_AUTHENTICATOR: 'Configura tu autenticador',
  SET_NEW_PASSWORD: 'Establecer nueva contraseña',
  SHARE_TRANSACTION_HASH: 'Compartir hash de transacción',
  SHOW_ROLE_DETAILS: 'Mostrar detalles del rol',
  SIGN_IN: 'Iniciar sesión',
  SIGN_OUT: 'Cerrar sesión',
  SIGN_UP: 'Registrarse',
  SIGN_UP_WITH_GOOGLE: 'Registrarse con Google',
  SIX_DIGIT_AUTHENTICATOR_CODE: 'Código de autenticador de 6 dígitos',
  SKIP_TWO_FACTOR_VERIFICATION: 'Omitir verificación de dos factores',
  SPECIAL_CHARACTER: 'carácter especial',
  SPEI_BANK_BENEFICIARY: 'Beneficiario',
  SPEI_BANK_NAME: 'Banco',
  SPEI_CLABE_COPIED: 'CLABE copiado.',
  SPEI_DEPOSIT_DESCRIPTION: 'Usa esta CLABE para realizar tu depósito.',
  STABLECOIN_WALLET: 'Cartera de stablecoin',
  START_CURRENCY: 'Starting currency',
  START_VERIFICATION: 'Iniciar verificación',
  STATE: 'Estado',
  STATUS: 'Estado',
  STEP: 'Paso',
  STREET_ADDRESS: 'Dirección',
  SUBMIT: 'Enviar',
  SUBMITTED: 'Enviado',
  SUITE_FLOOR_APT: 'Suite / Piso / Apto',
  SUPPORTING_DOCUMENTATION: 'Documentación de respaldo',
  SUPPORTING_DOCUMENTATION_DESCRIPTION:
    'Por razones de cumplimiento, este pago requiere un documento de respaldo, como una factura, contrato o recibo de pago. Esto no será enviado a su destinatario.',
  SWIFT: 'SWIFT',
  SWIFT_CODE: 'Código SWIFT',
  SWIFT_CODE_DETAILS: 'Código Swift',
  SWIFT_CURRENCY_INSTRUCTED_VERSUS_SETTLEMENT_TOOLTIP:
    'La instrucción de pago se denomina en USD. No obstante, la moneda de liquidación puede variar dependiendo del banco receptor y tipo de cuenta del destinatario.',
  SWIFT_MINIMUM_AMOUNT: 'El monto mínimo para transferencia SWIFT es 15000 USD',
  TAX: 'Impuesto ({0})',
  TEN_MIN: '10 min',
  TERMS_ACCEPT_ERROR: 'Debes aceptar los Términos de Servicio y la Política de Privacidad',
  TERMS_OF_SERVICE: 'Términos de Servicio',
  THEME: 'Tema',
  THESE_USERS: 'estes usuários',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'Esta acción no es reversible.',
  THIS_QUOTE_WILL_REMAIN_ACTIVE_FOR: 'Esta cotización permanecerá activa por',
  THIS_USER: 'este usuário',
  TIMEZONE_ALASKA_STANDARD_TIME: 'Hora Estándar de Alaska - AKST',
  TIMEZONE_ARGENTINA_TIME: 'Hora de Argentina - ART',
  TIMEZONE_BOLIVIA_TIME: 'Hora de Bolivia - BOT',
  TIMEZONE_BRAZIL_TIME: 'Hora de Brasília - BRT',
  TIMEZONE_CENTRAL_EUROPEAN_TIME: 'Hora Central Europea - CET',
  TIMEZONE_CENTRAL_STANDARD_TIME: 'Hora Estándar Central - CST',
  TIMEZONE_CHILE_TIME: 'Hora Estándar de Chile - CLT',
  TIMEZONE_COLOMBIA_TIME: 'Hora de Colombia - COT',
  TIMEZONE_EASTERN_EUROPEAN_TIME: 'Hora Oriental Europea - EET',
  TIMEZONE_EASTERN_STANDARD_TIME: 'Hora Estándar Oriental - EST',
  TIMEZONE_ECUADOR_TIME: 'Hora de Ecuador - ECT',
  TIMEZONE_GREENWICH_MEAN_TIME: 'Hora Media de Greenwich - GMT',
  TIMEZONE_GUYANA_TIME: 'Hora de Guyana - GYT',
  TIMEZONE_HAWAII_STANDARD_TIME: 'Hora Estándar de Hawái - HST',
  TIMEZONE_MOSCOW_TIME: 'Hora de Moscú - MSK',
  TIMEZONE_MOUNTAIN_STANDARD_TIME: 'Hora Estándar de Montaña - MST',
  TIMEZONE_PACIFIC_STANDARD_TIME: 'Hora Estándar del Pacífico - PST',
  TIMEZONE_PARAGUAY_TIME: 'Hora de Paraguay - PYT',
  TIMEZONE_PERU_TIME: 'Hora de Perú - PET',
  TIMEZONE_SURINAME_TIME: 'Hora de Surinam - SRT',
  TIMEZONE_URUGUAY_TIME: 'Hora de Uruguay - UYT',
  TIMEZONE_VENEZUELA_TIME: 'Hora de Venezuela - VET',
  TIMEZONE_WESTERN_EUROPEAN_TIME: 'Hora Occidental Europea - WET',
  TIME_ZONE: 'Zona horaria',
  TO: 'Para',
  TOO_SHORT: 'La contraseña es demasiado corta, debe tener un mínimo de 8 caracteres',
  TOTAL_AMOUNT: 'Monto total',
  TOTAL_FEES: 'Total de comisiones',
  TOTP_APP_FREEOTP_NAME: 'FreeOTP',
  TOTP_APP_GOOGLE_NAME: 'Google Authenticator',
  TOTP_APP_MICROSOFT_AUTHENTICATOR_NAME: 'Microsoft Authenticator',
  TOTP_DISABLED_ERROR: 'Ocurrió un error al deshabilitar la autenticación de dos factores',
  TOTP_DISABLED_SUCCESS: 'Autenticación de dos factores deshabilitada con éxito',
  TOTP_ENABLED_FAILED: 'Ocurrió un error al habilitar la autenticación de dos factores',
  TOTP_ENABLED_SUCCESS: 'Autenticación de dos factores habilitada con éxito',
  TOTP_STEP_1: 'Abre una aplicación de autenticación como Google Authenticator o FreeOTP',
  TOTP_STEP_2: 'Escanea el código QR usando la aplicación de autenticación',
  TOTP_STEP_3: 'Ingresa el código temporal generado con tu aplicación de autenticación',
  TO_DATE: 'Hasta (MM/AA)',
  TO_DATE_CANNOT_BE_AFTER_TODAY: 'La fecha final no puede ser posterior a la fecha de hoy',
  TO_DATE_MUST_BE_AFTER_FROM_DATE: 'La fecha final debe ser posterior a la fecha inicial',
  TRANSACTION_CONFIRMATION: 'Confirmación de transacción',
  TRANSACTION_DETAILS: 'Detalles de la transacción',
  TRANSACTION_DETAILS_TITLE: 'Detalles de la transacción',
  TRANSACTION_HASH: 'Hash de transacción',
  TRANSACTION_ID: 'ID de transacción#',
  TRANSACTION_NOT_FOUND: 'Transacción no encontrada',
  TRANSACTION_TYPE: 'Tipo de transacción',
  TRANSACTION_UETR: 'ID de transacción# (UETR)',
  TRANSFER: 'Transferir',
  TRANSFER_CREATED_DESCRIPTION: 'Recibe notificaciones cuando una transferencia haya sido creada',
  TRANSFER_CREATED_LABEL: 'Creada',
  TRANSFER_FEES_FREE: 'Comisiones de transferencia (Gratis)',
  TRANSFER_FEES_WITH_PERCENTAGE: 'Comisiones de transferencia ({0})',
  TRANSFER_FUNDS: 'Transferir fondos',
  TRANSFER_RECEIVED: 'Hemos recibido tu pago e iniciado tu transferencia',
  TRANSFER_STATUS: 'Estado de la transferencia',
  TRANSFER_TO: 'Transferencia a {0}',
  TREASURY_MANAGEMENT: 'Gestión de Tesorería',
  TREASURY_MANAGEMENT_DESC:
    'Optimiza las operaciones de tesorería internacional y los saldos de efectivo',
  TRY_CHANGING_YOUR_APPLIED_FILTERS: 'Intenta cambiar tus filtros aplicados para ver más {0}.',
  TWO_FACTOR_AUTHENTICATION: 'Escanea el código QR para obtener el código',
  TWO_FACTOR_AUTHENTICATION_DESCRIPTION:
    'Te recomendamos configurar una aplicación autenticadora para proteger mejor tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SECTION_DESCRIPTION:
    'Configura la autenticación de dos factores con una aplicación autenticadora para proteger tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SECTION_LABEL: 'Autenticación de dos factores',
  TWO_FACTOR_AUTHENTICATION_SETUP: 'Configurar autenticación de dos factores',
  TWO_FACTOR_AUTHENTICATION_SETUP_DESCRIPTION:
    'Te recomendamos configurar una aplicación autenticadora para proteger mejor tu cuenta',
  TWO_FACTOR_AUTHENTICATION_SETUP_SECRET: 'O ingresa esta clave secreta manualmente',
  TWO_FACTOR_DISABLED_ERROR: 'Ocurrió un error al deshabilitar la autenticación de dos factores',
  TWO_FACTOR_DISABLED_SUCCESS: 'Autenticación de dos factores deshabilitada con éxito',
  TWO_FACTOR_RESET_ERROR:
    'Error al restablecer la autenticación de dos factores. Inténtalo de nuevo.',
  TWO_FACTOR_RESET_SUCCESS:
    'La autenticación de dos factores se ha restablecido exitosamente. Serás desconectado en breve.',
  TYPE: 'Tipo',
  UNKNOWN: 'Desconocido',
  UNKNOWN_ERROR: 'Error desconocido',
  UNSET: '(No establecido)',
  UPDATE: 'Actualizar',
  UPDATE_ACCOUNT_INFORMATION: 'Actualizar información de la cuenta',
  UPDATE_CONTACT_SUCCESS: 'Contacto actualizado con éxito',
  UPDATE_EMAIL_ADDRESS_DESCRIPTION:
    'Confirmación cuando actualices tu dirección de correo electrónico para tu cuenta',
  UPDATE_EMAIL_ADDRESS_LABEL: 'Dirección de correo electrónico actualizada',
  UPDATE_PAYMENT_METHOD_SUCCESS: 'Método de pago actualizado con éxito',
  UPLOAD_DOCUMENT: 'Subir documento',
  USDC_AND_USDT: 'Rampas de entrada y salida de USDC y USDT para empresas de todos los tamaños',
  USDC_LABEL: 'USDC',
  USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY: 'USD (ACH y Wires)',
  USER: 'usuario',
  USERS: 'usuarios',
  USE_KEY: 'Usar clave',
  USE_YOUR_CALIZA_BALANCE: 'Usa tu saldo de Caliza',
  US_DOLLAR: 'US Dollar',
  VALIDATION_ACTIVE_USER_CONFLICT: 'Este correo electrónico ya está vinculado a un usuario activo',
  // New hardcoded strings that need translation
  VALIDATION_CVU_INVALID: 'CVU ou CBU debe tener exactamente 22 dígitos',

  VALIDATION_INVALID_SWIFT_CHARACTERS: 'El código SWIFT solo puede contener letras y números',

  VALIDATION_PASSWORD_MIN_8: 'La contraseña debe tener un mínimo de 8 caracteres',

  VALIDATION_PASSWORD_NUMBER: 'La contraseña debe tener un mínimo de 1 número',

  VALIDATION_PASSWORD_SPECIAL_CHARACTER:
    'La contraseña debe tener un mínimo de 1 carácter especial',

  VALIDATION_REQUIRED: '{0} is required',

  VALIDATION_TOO_LONG_16: '{0} debe tener menos de 16 caracteres',
  VALIDATION_TOO_LONG_20: '{0} debe tener menos de 20 caracteres',
  VALIDATION_TOO_LONG_70: '{0} debe tener menos de 70 caracteres',
  VALIDATION_USER_CONFLICT:
    'Ya se envió una invitación a este correo electrónico para unirse a tu equipo',
  VERIFY: 'Verificar',
  VERIFY_BUSINESS_ADDRESS: 'Dirección',
  VERIFY_BUSINESS_ADDRESS_LABEL: 'Dirección',
  VERIFY_BUSINESS_ADD_ANOTHER_OWNER: 'Agregar otro propietario',
  VERIFY_BUSINESS_ADD_SOCIAL_MEDIA: 'Agregar otro canal de redes sociales',
  VERIFY_BUSINESS_ANNUAL_INCOME: 'Ingreso anual',
  VERIFY_BUSINESS_BANK_STATEMENT: 'Estado de cuenta bancario',
  VERIFY_BUSINESS_BANNER: 'Verifica tu negocio para enviar tu primer pago',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_DESC:
    'A beneficial owner is any individual who directly or indirectly owns 25% or more of your company.',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_TITLE: 'Propietarios beneficiarios',
  VERIFY_BUSINESS_BENEFICIAL_OWNER_ADDRESS_QUESTION: "What is the beneficial owner's address?",
  VERIFY_BUSINESS_BENEFICIAL_OWNER_COUNTER: 'Propietario beneficiario #{0}',
  VERIFY_BUSINESS_BUSINESS_CONTACT_DESC:
    'The business representative is the primary point of contact who will manage the business relationship and ongoing operations with Caliza.',
  VERIFY_BUSINESS_BUSINESS_CONTACT_TITLE: 'Contacto de negocios',
  VERIFY_BUSINESS_CITY: 'Ciudad',
  VERIFY_BUSINESS_CNPJ: 'CNPJ',
  VERIFY_BUSINESS_CNPJ_FORMAT: 'El CNPJ debe seguir este formato: 12.345.678/9012-34',
  VERIFY_BUSINESS_CNPJ_QUESTION: '¿Cuál es el CNPJ?',
  VERIFY_BUSINESS_CNPJ_REGISTRATION: 'Registro CNPJ',
  VERIFY_BUSINESS_COMMERCIAL_NAME: 'Nombre comercial',
  VERIFY_BUSINESS_COMMERCIAL_NAME_QUESTION: "What is the company's commercial business name?",
  VERIFY_BUSINESS_COMPANY_DETAILS_TITLE: 'Detalles de la empresa',
  VERIFY_BUSINESS_COMPANY_PROFILE_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_COMPANY_PROFILE_TITLE: 'Perfil de la empresa',
  VERIFY_BUSINESS_CONTACT_INFORMATION: 'Información de contacto',
  VERIFY_BUSINESS_CONTACT_INFORMATION_QUESTION: '¿Cuál es su información de contacto?',
  VERIFY_BUSINESS_CONTACT_LABEL: 'Contacto',
  VERIFY_BUSINESS_CONTACT_QUESTION: '¿Quién es el punto de contacto para el negocio?',
  VERIFY_BUSINESS_COUNTRIES: 'Países',
  VERIFY_BUSINESS_CUSTOMER_COUNTRIES_QUESTION: '¿En qué países están ubicados tus clientes?',
  VERIFY_BUSINESS_CUSTOMER_DESCRIPTION: 'Una descripción de tu cliente',
  VERIFY_BUSINESS_CUSTOMER_INDUSTRIES_QUESTION:
    'Which industries do you have customers in? Select all that apply',
  VERIFY_BUSINESS_CUSTOMER_QUANTITY_QUESTION: '¿Cuántos clientes aproximados tienes?',
  VERIFY_BUSINESS_CUSTOMER_TYPE_QUESTION:
    'What type of customers do you have? Select all that apply',
  VERIFY_BUSINESS_DOCUMENTS: 'Documentos',
  // Additional tr() arguments that need symbols
  VERIFY_BUSINESS_DOCUMENTS_DESCRIPTION:
    'Please upload the company documents below. We support PDF, JPG, JPEG, PNG, and Word formats of a maximum size of [20] MB',
  VERIFY_BUSINESS_DOCUMENTS_TITLE: 'Documentos',
  VERIFY_BUSINESS_EMAIL: 'Correo electrónico',
  VERIFY_BUSINESS_EMAIL_QUESTION: '¿Cuál es su correo electrónico?',
  VERIFY_BUSINESS_ENTITY_TYPE: 'Tipo de entidad',
  VERIFY_BUSINESS_ENTITY_TYPE_QUESTION: '¿Cuál es el tipo de entidad?',
  VERIFY_BUSINESS_EXPECTED_RANGE: 'Rango $ esperado',
  VERIFY_BUSINESS_FINANCIAL_INSTITUTION_QUESTION: '¿Eres una institución de pago o financiera?',
  VERIFY_BUSINESS_FIRST_NAME: 'Nombre',
  VERIFY_BUSINESS_INCORPORATION_DOCUMENT: 'Documento de incorporación o estatutos de incorporación',
  VERIFY_BUSINESS_INDUSTRY_QUESTION: '¿En qué industria está tu negocio?',
  VERIFY_BUSINESS_LAST_NAME: 'Apellido',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME: 'Nombre de entidad legal',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_HELP:
    'Legal entity name must exactly match "NOME EMPRESARIAL" in your company\'s "CADASTRO NACIONAL DA PESSOA JURÍDICA" document.',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_QUESTION: '¿Cuál es el nombre de la entidad legal?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_DESC:
    'A legal representative is an individual with legal authority and powers to represent your company.',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_LABEL: 'Representante legal',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_QUESTION:
    'Who is the legal representative of this business?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_TITLE: 'Representante legal',
  VERIFY_BUSINESS_LICENSE_REQUIRED:
    'Are you required to have a license to operate in Brazil or another jurisdiction?',
  VERIFY_BUSINESS_MAIN_ADDRESS_QUESTION: "What is the company's main business address?",
  VERIFY_BUSINESS_MAIN_INDUSTRY: 'Industria principal',
  VERIFY_BUSINESS_NATIONALITY: 'Nacionalidad',
  VERIFY_BUSINESS_NUMBER_OF_CUSTOMERS: 'Número de clientes',
  VERIFY_BUSINESS_OCCUPATION: 'Ocupación',
  VERIFY_BUSINESS_ONLINE_PRESENCE_DESC:
    'Please share any other websites or online channels that could help us to better understand your business. These include social media accounts, e-commerce stores, and app store links.',
  VERIFY_BUSINESS_ONLINE_PRESENCE_TITLE: 'Presencia en línea',
  VERIFY_BUSINESS_OPERATIONS_TITLE: 'Operaciones del negocio',
  VERIFY_BUSINESS_OPERATION_COUNTRIES_QUESTION: '¿En qué países operas?',
  VERIFY_BUSINESS_OPERATION_STARTED: 'Operación iniciada',
  VERIFY_BUSINESS_OPERATION_START_QUESTION: '¿Cuándo comenzó operaciones la empresa?',
  VERIFY_BUSINESS_ORGANIZATION_TITLE: 'Organización',
  VERIFY_BUSINESS_OWNER: 'Propietario',
  VERIFY_BUSINESS_PERCENTAGE_OWNERSHIP: 'Porcentaje de propiedad',
  VERIFY_BUSINESS_PHONE: 'Teléfono',
  VERIFY_BUSINESS_PHONE_NUMBER: 'Número de teléfono',
  VERIFY_BUSINESS_PHONE_QUESTION: '¿Cuál es su número de teléfono?',
  VERIFY_BUSINESS_POSITION: 'Posición',
  VERIFY_BUSINESS_POSITION_QUESTION: '¿Cuál es su posición?',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY: 'Poder notarial',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY_HELP:
    'Please provide a standing general Power of Attorney or a limited Power of Attorney that assigns authority to open accounts and sign contracts on behalf of the business',
  VERIFY_BUSINESS_SERVICES_DESCRIPTION: 'Descripción de productos y servicios (Mínimo 8 palabras)',
  VERIFY_BUSINESS_SERVICES_QUESTION: '¿Qué productos o servicios ofrece tu negocio?',
  VERIFY_BUSINESS_SOCIAL_MEDIA_QUESTION: '¿Cuáles son tus canales de redes sociales? (Opcional)',
  VERIFY_BUSINESS_SOLE_PROPRIETOR_SKIP:
    'This section is not required since you are a sole proprietorship',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS: 'Fuente de fondos',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_TITLE: 'Fuente de fondos',
  VERIFY_BUSINESS_SOURCE_OF_WEALTH: 'Fuente de riqueza',
  VERIFY_BUSINESS_STATE: 'Estado',
  VERIFY_BUSINESS_SUITE_FLOOR_APT: 'Suite / Piso / Apto',
  VERIFY_BUSINESS_SUPPORTED_ID_DOCS:
    'Documentos de identificación admitidos (Pasaporte, Licencia de conducir o Registro General)',
  VERIFY_BUSINESS_TAX_ID: 'ID fiscal',
  VERIFY_BUSINESS_THIRD_PARTY_QUESTION:
    'Do you intend to use Caliza to move funds on behalf of customers or other third parties?',
  VERIFY_BUSINESS_TITLE: 'Información del negocio',
  VERIFY_BUSINESS_TYPICAL_CUSTOMER_QUESTION: 'Por favor, describe tu cliente típico',
  VERIFY_BUSINESS_UPLOAD_ID: 'Subir Pasaporte, Licencia de Conducir o Registro General',
  VERIFY_BUSINESS_URL: 'URL',
  VERIFY_BUSINESS_USD_VOLUME_QUESTION:
    'What is the expected monthly $USD volume you will move using Caliza?',
  VERIFY_BUSINESS_WEBSITE_LINK: 'Enlace del sitio web',
  VERIFY_BUSINESS_WEBSITE_QUESTION: '¿Cuál es el sitio web de tu negocio?',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_TITLE: 'Tus clientes',
  VERIFY_BUSINESS_ZIP: 'Código postal',
  VERIFY_YOUR_BUSINESS: 'Verifica tu negocio',
  VET: 'Valor Efectivo Total',
  VET_TOOLTIP:
    'VET representa la tasa integral implícita, considerando el spread, otras tarifas e impuestos aplicables',
  VIEWER: 'Visualizador',
  VIEWER_DESCRIPTION:
    'Acceso solo lectura a las cuentas de la empresa, ver y descargar informes de historial de transacciones e actividades',
  VIEW_ACTIVITY: 'Ver y descargar historial de transacciones y reportes de actividad',
  VIEW_AND_DOWNLOAD_TRANSACTIONS:
    'Ver y descargar historial de transacciones y reporte de actividad',
  WALLET: 'Cartera',
  WALLET_ADDRESS_COPIED: 'Dirección copiada exitosamente',
  WALLET_BALANCE: 'Saldo de cartera ${0} Dólares digitales',
  WALLET_INFORMATION: 'Wallet information',
  WALLET_INFORMATION_WITH_CURRENCY: 'Wallet information ({0})',
  WELCOME_BACK: 'Bienvenido de nuevo',
  WELCOME_TITLE: 'Bienvenido de nuevo, {0}',
  WE_ARE_DEPOSITING_YOUR_FUNDS: 'Estamos depositando tus fondos',
  WE_DONT_SUPPORT_YOUR_COUNTRY_YET: 'No damos soporte a tu país todavía',
  WE_RECEIVED_PAYMENT_INITIATED: 'Hemos recibido tu pago e iniciado tu transferencia',
  WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION:
    'Revisa tu historial para seguir el estado de la transferencia. Los detalles de la transacción pueden tardar unos minutos antes de aparecer.',
  WHERE_SENDING_FUNDS: 'Where are you sending funds?',
  WIRE: 'Wire',
  WITHDRAW: 'Retirar',
  WITHDRAWAL: 'Retiro',
  WITHDRAWAL_ACCOUNT: 'Cuenta de retiro',
  WITHDRAWAL_TO: 'Retiro a {0}',
  WITHDRAW_FUNDS: 'Retirar fondos',
  YEAR: 'Año',
  YES: 'Sí',
  YOU: 'Tú',
  YOURE_ALMOST_DONE: "You're almost done!",
  YOUR_ACCOUNT: 'Tu cuenta',
  YOUR_ACCOUNTS: 'Tus cuentas',
  YOUR_CALIZA_PASSWORD: 'Tu contraseña de Caliza',
  YOUR_FUNDS_HAVE_BEEN_ADDED: 'Tus fondos se han agregado a tu cuenta',
  YOUR_FUNDS_HAVE_BEEN_SENT: 'Tus fondos han sido enviados',
  YOU_DO_NOT_HAVE_ENOUGH_FUNDS: 'No tienes fondos suficientes para completar esta transacción',
  YOU_RECEIVE: 'Tú recibes',
  YOU_SEND: 'Tú envías',
  YOU_STILL_BE_ABLE_TO_EXPLORE_PRODUCT_DESCRIPTION:
    'Podrás seguir explorando nuestros productos, pero no podrás realizar pagos. Te notificaremos cuando estemos activos en tu país.',
  YOU_WITHDRAW: 'Tú retiras',
  ZERO_RESULTS_FOUND: '0 resultados encontrados',
  ZIP: 'Código postal',
};
export default strings;
